import { useContext } from 'react'

import { userContext } from './user-context'

export function useUser() {
  return useContext(userContext)
}
